import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createCanvas } from '../../../app/store/slices/canvasSlice';
import logo from '../../../assets/images/logos/576_Cash Canvas-02.png';
import { toast } from 'react-toastify'; // Add this import

const CreateCanvas = () => {
  const [canvasName, setCanvasName] = useState('');
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.canvas);

  const handleSubmit = async () => {
    const trimmedName = canvasName.trim();
    
    if (!trimmedName) {
      setError('Canvas name is required.');
      return;
    }

    if (trimmedName.length < 5) {
      setError('Canvas name must be at least 5 characters long.');
      return;
    }

    if (trimmedName.length > 30) {
      setError('Canvas name cannot exceed 30 characters.');
      return;
    }

    try {
     const result = await dispatch(createCanvas({ name: trimmedName })).unwrap();
     localStorage.setItem('onboardingCanvas', JSON.stringify(result))
    
    navigate('/update-user-currency', { 
      state: { canvasId: result._id } 
    });
    } catch (err) {
      // Handle duplicate canvas name error
      if (err?.status === 409 || err?.code === 'ERR_BAD_REQUEST' ||err==='Canvas with this name already exists') {
        toast.error('A canvas with this name already exists');
        setError('Please choose a different name for your canvas');
      } else {
        toast.error(err?.message || 'Failed to create canvas');
        setError(err?.message || 'Failed to create canvas');
      }
      console.error('Canvas creation failed:', err);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
       {/* Logo container with smaller responsive sizing */}
          <div className="fixed top-0 left-0 p-4">
            <img 
              src={logo} 
              alt="Cash Canvas Logo" 
              className="h-20 w-auto object-contain max-w-[150px]"
            />
          </div>
      <div className="card-setup">
        {/* Header */}
        <div className="text-center mb-10">
          <h1 className="txt-page-heading ">
            Create Your First Canvas
          </h1>
          <p className="p-tag-below-heading">
            A Canvas is a financial plan. This is where you can enter your account 
            <br></br>balances, manage your budget, savings, liabilities and investments.
          </p>
        </div>

        {/* Input */}
        <div className="w-full sm:w-3/4 md:w-2/3 lg:w-1/2 mx-auto">
          <input
            type="text"
            value={canvasName}
            onChange={(e) => setCanvasName(e.target.value)}
            placeholder="Enter Canvas name"
            className="input-field"
          />
          {error && <p className="text-sm text-red-600 mt-2">{error}</p>}
        </div>

      

        <div className="absolute bottom-6 right-6">
          <button
            onClick={handleSubmit}
            disabled={loading}
            className={`btn-continue ${loading ? 'opacity-75 cursor-not-allowed' : ''}`}
          >
            {loading ? (
              <span className="flex items-center gap-2">
                <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                  <circle 
                    className="opacity-25" 
                    cx="12" 
                    cy="12" 
                    r="10" 
                    stroke="currentColor" 
                    strokeWidth="4"
                  />
                  <path 
                    className="opacity-75" 
                    fill="currentColor" 
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
                Creating...
              </span>
            ) : (
              'Continue'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateCanvas;
